import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { BaseComponent } from 'app/shared/infrastructure';
import { ItemCategory, ItemTypes } from 'app/shared/models/orders-and-billing';

// Services
import { PatientService } from 'app/shared/services/core/patient';
import { FacilityUnitService } from 'app/shared/services/core/facilityUnit';
import { ItemService } from 'app/shared/services/order-and-billing/item';
import { ReceiveOrderStatusLookup } from 'app/shared/models/orders-and-billing/lookup/receive-order-status-lookup';
import { GenderTypeLookup } from 'app/shared/models';
import { ReceiveOrderSearch } from 'app/shared/models/orders-and-billing/receive-order-search.model';
import { ItemCategoryService } from 'app/shared/services';
@Component({
    selector: 'advance-search-receive-order-cmp',
    templateUrl: './advanceSearchReceiveOrder.html',
})

export class AdvanceSearchReceiveOrder extends BaseComponent implements OnInit {
    @Output() onSearch = new EventEmitter<any>();
    @Input() forReceiveOrder: boolean = false;

    receiveOrderStatus: SelectItem[];
    receiveOrderSearch: ReceiveOrderSearch = new ReceiveOrderSearch();

    patients: any;

    items: any;

    sections: any;

    genderTypes: any = [];
    itemCategories: any[] = [];
    pACSOptions: any[] = [];
    enablePacsCode: boolean = false;
    orderDatesCleared: boolean = false;

    ngOnInit() {

        this.getAllMedicalCategoryUserSections();
        this.receiveOrderStatus = ReceiveOrderStatusLookup.getAllLookupWithAll();
        this.receiveOrderSearch.fromOrderDate = new Date();
        this.receiveOrderSearch.toOrderDate = new Date();
        this.genderTypes = GenderTypeLookup.getLookup();
        this.genderTypes.unshift({ label: 'All', value: null });
        this.getItemCategories();
        this.getPACSCodes();
    }

    constructor(private patientService: PatientService,
        private facilityUnitService: FacilityUnitService,
        private itemService: ItemService,
        private itemCategoryService: ItemCategoryService) {
        super();
    }


    filterPatientByQuery(event) {
        const query = event.query;
        this.patientService.searchPatient(query)
            .subscribe((data: any[]) => {
                this.patients = data;
            });
    }

    onNationalIdChange() {
        if (this.forReceiveOrder && this.receiveOrderSearch.documentCode) {
            this.clearOrderDates();
        }
    }

    setPatient(event) {
        this.receiveOrderSearch.patientId = event.PatientId;
        if (this.forReceiveOrder && this.receiveOrderSearch.patientId) {
            this.clearOrderDates();
        }
    }

    private clearOrderDates() {
        if (!this.orderDatesCleared) {
            this.receiveOrderSearch.fromOrderDate = null;
            this.receiveOrderSearch.toOrderDate = null;
            this.orderDatesCleared = true;
        }
    }

    checkIfValidPatient(event) {
        if (!this.receiveOrderSearch.patientId) {
            event.target.value = '';
        }
    }

    clearPatient(event) {
        this.receiveOrderSearch.patientId = null;
    }

    filterItemByQuery(event) {
        const query = event.query;
        const itemCategories: number[] = [];
        itemCategories.push(ItemCategory.MedicalProcedures);
        itemCategories.push(ItemCategory.Radiology);
        itemCategories.push(ItemCategory.SurgeryOperations);
        itemCategories.push(ItemCategory.EndoscoptProcedures);
        itemCategories.push(ItemCategory.CathLab);
        itemCategories.push(ItemCategory.Pharmacy);
        this.itemService.getServiceAndParentItems(query, itemCategories.join(','))
            .subscribe((data: any[]) => {
                this.items = data;
            });
    }

    setItem(event) {
        this.receiveOrderSearch.itemId = event.Id;
        this.receiveOrderSearch.itemTypeId = event.Type;
        this.enablePacsCode = (event?.CategoryId === ItemCategory.Radiology && event?.Type === ItemTypes.Parent) ? true : false;
    }

    checkIfValidItem(event) {
        if (!this.receiveOrderSearch.itemId) {
            event.target.value = '';
        }
    }

    clearItem(event) {
        this.receiveOrderSearch.itemId = null;
        this.receiveOrderSearch.pacsCodes = [];
        this.receiveOrderSearch.categoryId = null;
        this.enablePacsCode = false;
    }

    getAllMedicalCategoryUserSections() {
        this.facilityUnitService.getAllNursesSections().subscribe((data: any[]) => {
            this.sections = [];
            data.forEach(element => {
                this.sections.push({ label: element.Title, value: element.Id })
            });
        });
    }

    onSubmit() {
        if (this.receiveOrderSearch.fromOrderDate && !this.receiveOrderSearch.toOrderDate) {
            this.showError('Please set To Order Date if you want to search between two dates');
            return;
        }
        if (this.receiveOrderSearch.toOrderDate && !this.receiveOrderSearch.fromOrderDate) {
            this.showError('Please set From Order Date if you want to search between two dates');
            return;
        }
        if (this.receiveOrderSearch.fromOrderDate > this.receiveOrderSearch.toOrderDate) {
            this.showError('From Date should be less than or equal To Date');
            return;
        }
        this.orderDatesCleared = false;
        const filter = Object.assign({}, this.receiveOrderSearch);
        this.onSearch.emit({ receiveOrderSearch: filter });
    }

    resetSearchParameters() {
        this.receiveOrderSearch = new ReceiveOrderSearch();
    }

    getItemCategories() {
        this.itemCategoryService.getAllActive().subscribe((data: any[]) => {
            this.itemCategories = this.mapToOptions(data, 'Title', 'Id');
        });
    }

    getPACSCodes() {
        this.itemService.getPACSCodes().subscribe((data: any[]) => {
            this.pACSOptions = this.mapPACSCodes(data);
        });
    }

    updateHidePACSCode() {
        this.enablePacsCode = this.receiveOrderSearch.categoryId === ItemCategory.Radiology;
        this.receiveOrderSearch.pacsCodes = [];
    }

    private mapToOptions(data: any[], labelKey: string, valueKey: string): any[] {
        return (data || []).map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    }

    private mapPACSCodes(pacsOptions: any[]): any[] {
        return (pacsOptions || []).map(option => ({
            label: option,
            value: option,
        }));
    }
}
